import Cookies from "js-cookie";
import { Navigate, Outlet } from "react-router-dom";
import TrackPageView from "../../TrackPages";

const AdminRouteProtection = () =>{
    const admin_id = Cookies.get("admin_id");
    const token = Cookies.get("token");;
    return(
        
        admin_id && token?
                <>
                <TrackPageView />
                <Outlet/>
                </>
                :
                <Navigate to='/'/>

    )
};
export default AdminRouteProtection;